<template>
  <div class="bg-gradient-to-b from-tile-500  to-tile-900">
    <div v-if="theme == 'head_navbar'">
      <div v-if="!loginPage" :class="{ showMenu: mobileShow }">
        <div class="">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <div>
                <a href="/" class="block">
                  <div
                    class="flex text-white justify-between items-center mr-4"
                  >
                    <h2 class=" text-white p-1 px-2 m-0 text-xl flex flex-col">
                      <span class="text-xs"><span class="">VIQQA</span></span>
              
                      <template v-if="$root.cache.me.team_id">
                    <span  v-if="$root.cache.me.team_id > 1" class="text-xl">
                      {{ $root.cache.me.team }}</span> 

                  <span v-else class="text-xl">{{ $root.config.appName }}</span>

                  </template>

                  <span v-else class="text-xl">{{ $root.config.appName }}</span>

                  

                    </h2>
                    <div>
                      <vk-spinner v-if="loading" ratio="0.5"></vk-spinner>
                    </div>
                  </div>
                </a>
              </div>
              <div class="flex items-center">
                <div
                  class="header-menu text-sm"
                  v-for="(table, index) in mainMenuTables"
                  :key="table.id"
                >
                  <template v-if="table.url">
                    <router-link :to="{ name: table.url, params: { index } }">
                      <div
                        :class="{
                          'active-url font-medium':
                            $route.params.index == index,
                        }"
                        class=" "
                      >
                        <vk-icon
                          ratio="1"
                          class="opacity-40"
                          :icon="table.icon"
                        ></vk-icon>
                        <div
                          class=" flex w-full  justify-between   items-center"
                        >
                          <div v-if="menuNameShow">{{ table.name }}</div>
                        </div>
                      </div>
                    </router-link>
                  </template>
                  <template v-else>
                    <router-link
                      :to="{
                        name: 'list',
                        params: { index, table: table.table },
                      }"
                    >
                      <div
                        :class="{
                          'active-url font-medium':
                            $route.params.table == table.table,
                        }"
                        class="url"
                      >
                        <vk-icon
                          ratio="1"
                          class="opacity-40"
                          :icon="table.icon"
                        ></vk-icon>
                        <div
                          class=" flex w-full  justify-between   items-center"
                        >
                          <span v-if="menuNameShow"> {{ table.name }} </span>
                          <span
                            class="text-gray-100 hover:text-white"
                            v-if="$route.params.table == table.table"
                            @click="reload()"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="w-4 h-4 cursor-pointer"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M4 20v-7h7l-3.217 3.22A5.917 5.917 0 0 0 12 18a6 6 0 0 0 5.648-4h.018c.114-.325.201-.66.259-1h2.012A8 8 0 0 1 12 20h-.01a7.941 7.941 0 0 1-5.653-2.34L4 20Zm2.074-9H4.062a8 8 0 0 1 7.933-7H12a7.94 7.94 0 0 1 5.654 2.34L20 4v7h-7l3.222-3.22A5.916 5.916 0 0 0 12 6a6 6 0 0 0-5.648 4h-.018c-.115.325-.202.66-.259 1h-.001Z"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </router-link>
                  </template>
                </div>
              </div>
              <h5 class="text-xs px-3 text-white m-0 p-0 mb-1">Raporlar</h5>
              <div class="flex items-center">
                <!-- Kategori Menüleri -->
                <div
                  v-if="reportCategories && reportCategories.length > 0"
                  class="header-menu text-sm"
                  v-for="(category, index) in reportCategories"
                  :key="category.id"
                >
                  <a :href="'/reports?category_id=' + category.id">
                    <div class="url flex w-full items-center justify-start">
                      <vk-icon
                        ratio="1"
                        class="opacity-40"
                        :icon="category.icon || 'list'"
                      ></vk-icon>
                      <div
                        class=" flex w-full  justify-between   items-center"
                      >
                        <div v-if="menuNameShow">{{ category.name }}</div>
                      </div>
                    </div>
                  </a>
                </div>
                
                <!-- Mevcut Report Menüleri -->
                <div
                  class="header-menu text-sm"
                  v-for="(table, index) in reportMenuTables"
                  :key="table.id"
                >
                  <template v-if="table.url">
                    <a :href="'/' + table.url">
                      <div class="url flex w-full items-center justify-start">
                        <vk-icon
                          ratio="1"
                          class="opacity-40"
                          :icon="table.icon"
                        ></vk-icon>
                        <div
                          class=" flex w-full  justify-between   items-center"
                        >
                          <div v-if="menuNameShow">{{ table.name }}</div>
                        </div>
                      </div>
                    </a>
                  </template>
                  <template v-else>
                    <a :href="'/list/' + table.table">
                      <div class="url">
                        <vk-icon
                          ratio="1"
                          class="opacity-40"
                          :icon="table.icon"
                        ></vk-icon>
                        <div
                          class=" flex w-full  justify-between   items-center"
                        >
                          <span v-if="menuNameShow"> {{ table.name }} </span>
                        </div>
                      </div>
                    </a>
                  </template>
                </div>
              </div>
            </div>
            <div class="flex item-center">
              <div class=" text-white">
                <h5
                  class="text-xs flex items-center space-x-2 text-white cursor-pointer m-0 p-2 mb-1 hover:bg-white hover:bg-opacity-10 rounded"
                  @click="$emit('openFavoritesDrawer')"
                >
                  <svg
                    version="1.1"
                    meta="vk-icons-heart"
                    class="w-4 h-4 "
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill="none"
                      stroke="#fff"
                      stroke-width="1"
                      d="M10,4 C10,4 8.1,2 5.74,2 C3.38,2 1,3.55 1,6.73 C1,8.84 2.67,10.44 2.67,10.44 L10,18 L17.33,10.44 C17.33,10.44 19,8.84 19,6.73 C19,3.55 16.62,2 14.26,2 C11.9,2 10,4 10,4 L10,4 Z"
                    ></path>
                  </svg>
                  <span v-if="menuNameShow">Favoriler</span>
                  <span v-if="favorites.length > 0" class="bg-white bg-opacity-20 text-white px-1.5 py-0.5 rounded-full text-xs ml-auto">
                    {{ favorites.length }}
                  </span>
                </h5>
              </div>
              <div class=" text-white">
                <h5
                  class="text-xs flex items-center space-x-2 text-white cursor-pointer m-0 p-2 mb-1"
                  @click="sidebarNoteToggle()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M5 18.77v-1h1.615V9.845q0-1.96 1.24-3.447Q9.097 4.912 11 4.546V3h2v1.546q1.904.366 3.144 1.853q1.24 1.488 1.24 3.447v7.923H19v1H5Zm7-7.155Zm0 9.77q-.671 0-1.143-.473q-.472-.472-.472-1.143h3.23q0 .671-.472 1.144q-.472.472-1.143.472Zm-4.385-3.616h8.77V9.846q0-1.823-1.281-3.104q-1.28-1.28-3.104-1.28t-3.104 1.28q-1.28 1.281-1.28 3.104v7.923ZM3.231 9.827q0-1.923.766-3.578q.766-1.655 2.084-2.857l.675.735q-1.173 1.061-1.85 2.525q-.675 1.463-.675 3.175h-1Zm16.538 0q0-1.712-.676-3.185t-1.849-2.534l.675-.716q1.318 1.202 2.084 2.857q.766 1.655.766 3.578h-1Z"
                    />
                  </svg>
                  <span v-if="menuNameShow">Yaklaşan 10 Hatırlatma</span>
                </h5>
              </div>
              <div>
                <div
                  class="
              cursor-pointer
              p-2 
              flex
              justify-between
              items-center
            "
                >
                  <div class="" @click="sidebarProfile = !sidebarProfile">
                    <span class="text-white  font-light text-xs"
                      >Hoşgeldiniz,</span
                    >
                    <br />
                    <span class="text-white font-bold">{{ userName }}</span>
                  </div>
                  <div class="flex items-center justify-center">
                    <div
                      @click="openNotifications()"
                      class="flex w-10 items-center justify-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="opacity-40 w-6 h-6 text-white"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M12 18.5q.625 0 1.063-.437T13.5 17h-3q0 .625.438 1.063T12 18.5m0 3.5q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m-4-6h8q.425 0 .713-.288T17 15q0-.425-.288-.712T16 14v-2.6q0-1.525-.788-2.787T13 7v-.5q0-.425-.288-.712T12 5.5q-.425 0-.712.288T11 6.5V7q-1.425.35-2.212 1.613T8 11.4V14q-.425 0-.712.288T7 15q0 .425.288.713T8 16"
                        />
                      </svg>

                      <div
                        v-if="notificationCount > 0"
                        class="bg-red-500 absolute ml-3 -mt-3 text-white rounded-full px-1 text-xs"
                      >
                        {{ notificationCount }}
                      </div>
                    </div>
                    <router-link
                      to="/logout"
                      class="flex w-10 items-center justify-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="opacity-40 w-6 h-6 text-white"
                        viewBox="0 0 512 512"
                      >
                        <path
                          d="M192 277.4h189.7l-43.6 44.7L368 352l96-96-96-96-31 29.9 44.7 44.7H192v42.8z"
                          fill="currentColor"
                        />
                        <path
                          d="M255.7 421.3c-44.1 0-85.5-17.2-116.7-48.4-31.2-31.2-48.3-72.7-48.3-116.9 0-44.1 17.2-85.7 48.3-116.9 31.2-31.2 72.6-48.4 116.7-48.4 44 0 85.3 17.1 116.5 48.2l30.3-30.3c-8.5-8.4-17.8-16.2-27.7-23.2C339.7 61 298.6 48 255.7 48 141.2 48 48 141.3 48 256s93.2 208 207.7 208c42.9 0 84-13 119-37.5 10-7 19.2-14.7 27.7-23.2l-30.2-30.2c-31.1 31.1-72.5 48.2-116.5 48.2z"
                          fill="currentColor"
                        />
                        <path
                          d="M448.004 256.847l-.849-.848.849-.849.848.849z"
                          fill="currentColor"
                        />
                      </svg>
                    </router-link>
                  </div>
                  <div class="admin-dropdown" v-if="sidebarProfile">
                    <div class="admin-dropdown-header">
                      <div class="user-avatar">
                        <vk-icon ratio="1.2" icon="user" />
                      </div>
                      <div class="user-info">
                        <span class="user-name">{{ userName }}</span>
                        <span class="user-role">Kullanıcı ID: {{ userID }}</span>
                      </div>
                      <button @click="sidebarProfile = false" class="admin-close-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24">
                          <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"/>
                        </svg>
                      </button>
                    </div>
                    
                    <div class="admin-dropdown-content">
                      <div class="admin-menu-section">
                        <span class="admin-menu-title">Kullanıcı İşlemleri</span>
                        <router-link class="admin-menu-item" to="/profile">
                          <div class="admin-menu-icon">
                            <vk-icon ratio="0.8" icon="user" />
                          </div>
                          <span>Profil Bilgileri</span>
                        </router-link>
                      </div>
                      
                      <div class="admin-menu-section">
                        <span class="admin-menu-title">Yönetim</span>
                        
                        <router-link class="admin-menu-item" to="/admin">
                          <div class="admin-menu-icon">
                            <vk-icon ratio="0.8" icon="unlock" />
                          </div>
                          <span>Yönetim Paneli</span>
                        </router-link>
                      </div>
                      
                      <div class="admin-dropdown-footer">
                        <router-link class="admin-logout-button" to="/logout">
                          <vk-icon ratio="0.8" icon="sign-out" />
                          <span>Çıkış Yap</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-1 min-h-screen">
        <router-view
          class="m-2 md:mx-0 md:my-2 min-h-screen  bg-white border shadow rounded-lg"
        />
      </div>
    </div>

    <vk-offcanvas-content class="shadow notification-list">
      <vk-offcanvas flipped :show.sync="notificationList">
        <h3 class="font-medium text-lg">
          Bildirimler ({{ notificationCount }})
        </h3>
        <vk-offcanvas-close
          @click="notificationList = false"
        ></vk-offcanvas-close>
        <NotificationsVue :notifications="notifications" />
      </vk-offcanvas>
    </vk-offcanvas-content>
    
    <div v-if="sidebarNotes.length > 0 && sidebarNoteShow" class="notification-dropdown">
      <div class="notification-header">
        <h3 class="m-0 p-2 text-white text-sm font-medium">Yaklaşan Hatırlatmalar ({{ sidebarNotes.length }})</h3>
        <button @click="sidebarNoteToggle()" class="notification-close-btn">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"/>
          </svg>
        </button>
      </div>
      <div class="notification-body">
        <a 
          v-for="note in sidebarNotes.slice(0, 5)" 
          :key="note.lead_id"
          :href="'/leadDetail/' + note.lead_id" 
          class="notification-item"
        >
          <div class="notification-content">
            <p class="notification-title">{{ note.lead_name }}</p>
            <p class="notification-text">{{ note.body }}</p>
          </div>
        </a>
        <div v-if="sidebarNotes.length > 5" class="notification-footer">
          <a href="/notifications" class="view-all">Tümünü görüntüle ({{ sidebarNotes.length }})</a>
        </div>
      </div>
    </div>
    
    <!-- Admin Panel Overlay -->
    <div v-if="sidebarProfile" class="admin-overlay" @click="closeAllDropdowns"></div>
  </div>
</template>
<script>
import AuthService from "./services/auth";
import EventBus from "./components/Ui/EventBus";

import NotificationsVue from "./components/Ui/Notifications.vue";
import notificationStore from "./services/notificationStore";
import http from "./services/http";
export default {
  components: {
    NotificationsVue,
  },

  props: [
    "favorites",
    "userName",
    "userID",
    "sidebarNotes",
    "notifications",
    "notificationCount",
  ],
  data() {
    return {
      messages: [],
      mobileShow: false,
      menuNameShow: true,
      messagesType: "primary",
      loginPage: true,
      loading: true,
      sidebarProfile: false,
      themeBackground: null,
      searchValue: null,
      routeSelected: this.$route.params.index,
      searchTable: "leads",
      favoriteShow: false,
      sidebarNoteShow: false,
      show: false,
      isOpen: false,
      notificationList: false,
      results: [],
      search: "",
      themeStyle: 1,
      theme: "head_navbar",
      themeDark: false,
      themeMenuShow: 250,
      isLoading: false,
      arrowCounter: -1,
      reportCategories: [],
    };
  },
  computed: {
    mainMenuTables() {
      return this.$root.cache.tables ? this.$root.cache.tables.filter(table => table.location == 1) : [];
    },
    reportMenuTables() {
      return this.$root.cache.tables ? this.$root.cache.tables.filter(table => table.location == 4) : [];
    }
  },
  created() { 
    this.loading = false;
    this.checkLoginPage();
    this.getReportCategories();
    if (localStorage.theme) {
      this.theme = localStorage.theme;
    }
  },
  methods: {
    openNotifications() {
      this.notificationList = true;
      // Panel açıldığında okunmamış rozeti sıfırlanır.
      notificationStore.markAllSeen();
    },

    getReportCategories() {
      http.getReportCategories().then((resp) => {
        if (resp.data.success && resp.data.categories) {
          this.reportCategories = resp.data.categories;
        }
      }).catch(() => {
        // API hatası durumunda boş bırak
        this.reportCategories = [];
      });
    },
    getFavorites() {
      http.getFavorites().then((resp) => {
        this.favorites = resp.data;
      });
    },
    sidebarNoteToggle() {
      this.sidebarNoteShow = !this.sidebarNoteShow;
      localStorage.sidebarNoteShow = this.sidebarNoteShow;
    },
    favoriteToggle() {
      this.favoriteShow = !this.favoriteShow;
      localStorage.favoriteShow = this.favoriteShow;
    },
    closeAllDropdowns() {
      this.sidebarProfile = false;
      this.favoriteShow = false;
      this.sidebarNoteShow = false;
    },
    reload() {
      EventBus.$emit("reflesh", true);
    },
    removeFavorite(id) {
      http.removeFavorite(id).then(() => {
        this.getFavorites();
      });
    },
    logout() {
      AuthService.logout().then(() => {
        this.$router.push("logout");
      });
    },
    checkLoginPage() {
      if (this.$route.meta.requiresAuth == false) {
        this.loginPage = true;
      } else {
        this.loginPage = false;
      }
    },
  },
};
</script>

<style scoped>
.header-menu {
  @apply p-2 text-white bg-tile-600 mr-2 rounded-lg;
}
.header-menu a div {
  @apply flex items-center  space-x-2 text-white;
}
.header-menu a {
  @apply text-white;
}
.favorite-item:hover .favorite-remove {
  display: block;
}

.favorite-remove {
  display: none;
}

.favorite-remove:hover {
  @apply text-red-400;
}

.mobile-menu a {
  @apply text-white;
}

/* Notification dropdown styles */
.notification-dropdown {
  position: absolute;
  top: 60px;
  right: 100px;
  width: 320px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.15);
  z-index: 1000;
  overflow: hidden;
  animation: slideDown 0.3s ease;
}

.notification-header {
  background: linear-gradient(to right, #3b6181, #2a455e);
  padding: 10px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notification-close-btn {
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.notification-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.notification-body {
  max-height: 350px;
  overflow-y: auto;
}

.notification-item {
  display: block;
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
}

.notification-item:hover {
  background-color: #f9f9f9;
  text-decoration: none;
}

.notification-content {
  color: #333;
}

.notification-title {
  font-weight: 600;
  margin: 0 0 5px 0;
  font-size: 14px;
  color: #2a455e;
}

.notification-text {
  margin: 0;
  font-size: 12px;
  color: #666;
}

.notification-footer {
  padding: 10px 15px;
  text-align: center;
  background-color: #f5f5f5;
}

.view-all {
  font-size: 12px;
  color: #3b6181;
  font-weight: 500;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Admin dropdown styles */
.admin-dropdown {
  position: absolute;
  top: 60px;
  right: 20px;
  width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.2);
  z-index: 1050;
  overflow: hidden;
  animation: slideDown 0.3s ease;
}

.admin-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1040;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.admin-dropdown-header {
  background: linear-gradient(to right, #3b6181, #2a455e);
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  position: relative;
}

.admin-close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.admin-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.user-avatar {
  background-color: rgba(255,255,255,0.2);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-name {
  color: white;
  font-weight: 600;
  font-size: 14px;
}

.user-role {
  color: rgba(255,255,255,0.8);
  font-size: 12px;
}

.admin-dropdown-content {
  padding: 10px 0;
}

.admin-menu-section {
  padding: 0 15px;
  margin-bottom: 10px;
}

.admin-menu-title {
  display: block;
  font-size: 12px;
  color: #888;
  margin-bottom: 5px;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}

.admin-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  color: #333;
  text-decoration: none;
  transition: all 0.2s;
  border-radius: 4px;
  margin-bottom: 2px;
}

.admin-menu-item:hover {
  background-color: rgba(59, 97, 129, 0.1);
  padding-left: 15px;
  color: #3b6181;
}

.admin-menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: rgba(59, 97, 129, 0.1);
  border-radius: 4px;
  color: #3b6181;
}

.admin-dropdown-footer {
  border-top: 1px solid #eee;
  padding: 15px;
  display: flex;
  justify-content: center;
}

.admin-logout-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #f5f5f5;
  color: #666;
  border-radius: 4px;
  transition: all 0.2s;
  font-size: 13px;
}

.admin-logout-button:hover {
  background-color: #e53e3e;
  color: white;
}

/* Favorites dropdown styles */
.favorites-dropdown {
  position: absolute;
  top: 60px;
  right: 140px;
  width: 320px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.2);
  z-index: 1050;
  overflow: hidden;
  animation: slideDown 0.3s ease;
}

.favorites-header {
  background: linear-gradient(to right, #3b6181, #2a455e);
  padding: 10px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.favorites-close-btn {
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.favorites-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.favorites-body {
  max-height: 350px;
  overflow-y: auto;
}

.favorite-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  text-decoration: none;
}

.favorite-item:hover {
  background-color: #f9f9f9;
}

.favorite-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.favorite-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: rgba(59, 97, 129, 0.1);
  border-radius: 50%;
  color: #3b6181;
}

.favorite-title {
  margin: 0;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.favorite-delete {
  color: #999;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  transition: all 0.2s;
}

.favorite-delete:hover {
  color: #e74c3c;
  background-color: rgba(231, 76, 60, 0.1);
}

.favorites-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.empty-icon {
  color: #3b6181;
  opacity: 0.3;
  margin-bottom: 15px;
}

.empty-text {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 500;
  color: #666;
}

.empty-help {
  margin: 0;
  font-size: 12px;
  color: #999;
  max-width: 220px;
}
</style>
